import { useContext } from "react";
import { Context } from "Context";

const AriaLiveRegion = () => {
	const { ariaLiveRef } = useContext(Context);
	return (
		<div
			id="syndicated-aria-live"
			aria-live="polite"
			ref={ariaLiveRef}
			aria-relevant="additions"
			aria-atomic="true"
			className="syndicated-accessible-text"
		></div>
	);
};

export default AriaLiveRegion;
